import { useEffect, useState } from 'react';

export function useDebounce(value: string, delay = 500): string {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(
      () =>
        // remove any prefix before the first dash
        setDebouncedValue(value.replace(/^[^-]*-/, '')),
      delay,
    );

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
